﻿import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute,Params } from '@angular/router';
import { GenService } from '../../shared/gen-ser.service';
import { DataService } from '../../shared/dataservice.service';

import { NotificationsService } from 'angular2-notifications';
import { InprocessQualityIssues, IQIToken, IQIDayToken, DailyTokenItem, DailyToken, GenResponse } from '../../shared/misc-classes';
import { ModalDirective } from "ngx-bootstrap";
import { ErrorPopupComponent } from '../../common/error-popup/error-popup.component';


@Component({
  selector: 'app-inpr-qual-issu',
  templateUrl: './inpr-qual-issu.component.html',
  styleUrls: ['./inpr-qual-issu.component.css']
})
export class InprQualIssuComponent implements OnInit {

  currMonthDtObj:Date = new Date();
  areChangesMade: boolean = false;

  editRow:IQIToken;
  inProcessQualObj:InprocessQualityIssues;
  IQIDayTokenObj:IQIDayToken;
  isFullScrDaySel:boolean = false;
  selectedDayIndex:number = 0; 
  selView:number = 1;

  isLoading:boolean = false;
  isLoaded:boolean = false;
  isFailed:boolean = false;
  failMessage:string = '';
  mId:string = "773881e1-3f3a-49be-865a-1a2f0312be8d";
  hasmodaccess:boolean = false;
  daywiseItemList: Array<DailyToken>;
  editHeader: string ="";
  generateExcelFromDate:any;
  generateExcelToDate:any;

 @ViewChild('childModal') public childModal:ModalDirective; 
 @ViewChild(ErrorPopupComponent) errorPopup:ErrorPopupComponent;

  constructor(private _dataService:DataService,private _activatedRoute:ActivatedRoute, private _notify:NotificationsService) { }

  ngOnInit() {
    this._dataService.currPageName = "Inprocess Quality Issues";

    this._activatedRoute.queryParams.subscribe((params:Params) => {
      if(params['month']){
        this.currMonthDtObj = new Date(parseInt(params['month']));
      }
      this.loadMonthData();
    });
  }

  checkModAccess():boolean{
    if(this._dataService.mAccess(this.mId) == true){
      this.hasmodaccess = true; 
    }
    else{
      this.hasmodaccess = false; 
    }
    return this.hasmodaccess;
  }
  hasEditAccess(_pid:string){
    return this._dataService.hasEditAccess(this.mId,_pid);
  }
  hasReadAccess(_pid:string){
    return this._dataService.hasReadAccess(this.mId,_pid);
  }
  changesMade(flag:boolean){
    this.areChangesMade = flag;
  }
  
  public prevMonthSel():void{
    this.currMonthDtObj.setMonth(this.currMonthDtObj.getMonth() - 1);
    this.currMonthDtObj.setDate(1);
    this.loadMonthData();
  }
  nextMonthSel(){
    this.currMonthDtObj.setMonth(this.currMonthDtObj.getMonth() + 1);
    this.currMonthDtObj.setDate(1);
    this.loadMonthData();
  }
  

  formatMonth(_dateObj:Date):string{
    if(_dateObj){
      return GenService.getDateFormatStr(_dateObj , "MMM-YYYY");
    }
    return '-';
  }
  ItemSelected(_evntObj){
    this.selView = 1;
    this.currMonthDtObj.setDate(_evntObj.selDate.getDate());
    this.loadDateData();
  }
  private getDisplayTokenName(_custId:string,_quantity:number){
    return this._dataService.getProductName(_custId) ;
  }
  private getIdObj(_selDate:Date,_itemIndex:number){
    return {"selDate":_selDate,"rowIndex":_itemIndex}
  }
  
 loadMonthData(){
    this.isLoading = true;
    this.isLoaded = false;
    this.isFailed = false;
    this.failMessage = '';
    this.areChangesMade = false;
    this._dataService.loadinprocessqualityissues(this.currMonthDtObj).subscribe((_cstInspPlan:InprocessQualityIssues) => {
      if(_cstInspPlan!=null){
          this.inProcessQualObj = _cstInspPlan;
          this.loadDateData();
          
          let _tmpDailyTokenList: Array<DailyToken> = [];
          for (var i = 0; i < this.inProcessQualObj.dayTokens.length; i++) {
            let _tmpDate:Date = this.inProcessQualObj.dayTokens[i].selDate;
            let _tmpDailyTokens:Array<DailyTokenItem> = [];            
            let _indexer:number = 0;
            this.inProcessQualObj.dayTokens[i].dateTokens.forEach((_tmpObj:IQIToken) => {
              _tmpDailyTokens.push(new DailyTokenItem( this.getDisplayTokenName(_tmpObj.productName,0), this.getIdObj(_tmpDate,_indexer),''));
              _indexer++;
            });
            _tmpDailyTokenList.push(new DailyToken(_tmpDate, _tmpDailyTokens));
          }
  
          this.daywiseItemList = _tmpDailyTokenList;
          this.isLoaded = true;
          this.isLoading = false;
          this.isFailed = false;
        }
        else{
          this.daywiseItemList = null
          this.isLoaded = false;
          this.isLoading = false;
          this.isFailed = true;
          this.failMessage = "Failed to get data from database, try again";
        }
    });
  }
  validateData():boolean{
    return true;
  }
  saveData(_sendMail:boolean):void{
    if(this.validateData()==true){
      this._dataService.saveInprocessQualityIssues(this.inProcessQualObj,_sendMail)
      .subscribe((resp:GenResponse) => {
        if(resp.status == DataService.statusFail){
          if (resp.errorCode == DataService.staleDataCode) {
            this.errorPopup.showErrorPopup("Stale Data", DataService.staleDateErrorMsg)
          } else {
            this._notify.error('Failure', resp.details, this._dataService.failureOptions);
          }
        }
        else{
          this._notify.success('Success',resp.details,this._dataService.successOptions);
          this.loadMonthData();
        }

      });
    }
  }

  
  public getSelYear(): number {
    return this.currMonthDtObj.getFullYear();
  }
  public getSelMonth(): number {
    return this.currMonthDtObj.getMonth() + 1;
  }
  public setView(_viewNo: number): void {
    this.selView = _viewNo;
  }

  
  parseDate(dateString: string): Date {
    if (dateString) {
        return new Date(dateString);
    } else {
        return null;
    }
  }
  formatHeaderDate(_date:Date):string{
    if (_date) {
      return GenService.getDateFormatStr(_date, "DD-MMM");
    }
    return '-';
  }
  formatDate(_date:Date):string{
    if(_date){
      return GenService.getDateFormatStr(_date, "DD-MM-YYYY");
    }
    return '-';
  }




  changeScreenMode(_dayIndex:number){
    if(this.isFullScrDaySel == true){
      this.isFullScrDaySel = false;
    }
    else{
      this.isFullScrDaySel = true;
      this.selectedDayIndex = _dayIndex;
    }
  }
   loadDateData():void{
    let _tmpDPHDayToken:IQIDayToken = this.inProcessQualObj.getDateToken(this.currMonthDtObj);
    if(_tmpDPHDayToken == null){
      this.inProcessQualObj.addDateToken(this.currMonthDtObj);  
      _tmpDPHDayToken = this.inProcessQualObj.getDateToken(this.currMonthDtObj);
    }
    this.IQIDayTokenObj = _tmpDPHDayToken;
  }
  discardData():void{
    this.loadMonthData();
  }
  removeRecord(_tokenIndex:number){
        this.areChangesMade = true;
        this.IQIDayTokenObj.removeToken(_tokenIndex);
  }
 
  exportToExcel(){
    var startDate = new Date(this.generateExcelFromDate);
    var endDate  = new Date(this.generateExcelToDate);
    if(this.validateStartEndDate(startDate,endDate)){
        this._dataService.downloadFile(startDate,endDate,"Inprocess");
        this.hideChildModal();
    }
  }
  
  validateStartEndDate(_startDate:Date,_endDate:Date):boolean{
    if(_startDate > _endDate){
      this._notify.error('Failure','Invalid Date',this._dataService.failureOptions);
      return false;
    }

    return true;
  }
  
  showExportModel(){
    this.editHeader = "Export To Excel";
    this.generateExcelFromDate = GenService.getDateFormatStr(new Date(), "DD MMM YYYY");
    this.generateExcelToDate = GenService.getDateFormatStr(new Date(), "DD MMM YYYY");
    this.childModal.show();

  }

  hideChildModal(){
     this.childModal.hide();
  }

}
